export const videos = [
    'OIjyDLBBH68',
    '7pvw14BftCc',
    'nwnb3tGhGss',
    'JSnNrkBitLE',
    'DPcXqiJypbk',
    'UDnfwwxsEUc'
]; 
